<template>
  <div class="container" style="margin-top:150px;margin-bottom:50px;">
    <div class="container text-center">
      <h2 class="mb-5" style="color:#727272"><strong>We Can't find the page you requested</strong></h2>
      <p>You might have followed an incorrect link or mistyped an URL <br>But you can access our site by using the links provided below</p>
      <a href="/recruit" class="btn btn-primary" style="color:white">Home</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "pageNotFound",
  mounted() {
    axios.post('/404.html')
      .then(function () {
        // do nothing
      })
      .catch(function () {
        // do nothing
      });
  }
}
</script>

<style scoped>

</style>